export default "__VITE_ASSET__CNhNkDMX__"